import React from 'react';
import ReactDOM from 'react-dom';
import 'styles/index.css';
import App from 'components/App';
import { unregister } from 'registerServiceWorker';
import { createServer } from 'server/config';
import { HashRouter as Router } from 'react-router-dom';

if (process.env.REACT_APP_ENABLE_API_MOCKS) createServer();

ReactDOM.render(<Router><App /></Router>, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js